// A request id is its trace id (spec/08 §2.11): the same 128 bits, written as a TypeID so it can be
// read out over the phone. The trace viewer knows the trace by the 32 hex characters, so the screen
// shows those too, turned by the contract's own TypeID codec — nothing else takes an id apart.
//
// Where the traces are read is the deployment's choice (spec/19: Grafana Cloud or a self-hosted
// SigNoz), so the link comes from the build: `VITE_CLAVIAN_TRACE_URL`, the viewer's address for one
// trace with `{traceId}` where the id goes (`{requestId}` is offered too). Unset — as it is until a
// viewer is chosen — the screen shows the trace id and no link.

import { typeIdToUuid } from '@clavian/contracts/typeid';

/** `req_…` → the W3C trace id, 32 lower-case hex characters. */
export function traceIdOf(requestId: string): string | undefined {
  try {
    return typeIdToUuid('req', requestId).replaceAll('-', '');
  } catch {
    return undefined;
  }
}

/** The trace viewer's page for this request, when the build names a viewer (an `https:` or `http:` address). */
export function traceUrlOf(requestId: string, template: string | undefined = import.meta.env.VITE_CLAVIAN_TRACE_URL): string | undefined {
  const traceId = traceIdOf(requestId);
  if (template === undefined || template === '' || traceId === undefined) return undefined;
  const url = template.replaceAll('{traceId}', traceId).replaceAll('{requestId}', requestId);
  try {
    const parsed = new URL(url);
    return parsed.protocol === 'https:' || parsed.protocol === 'http:' ? parsed.toString() : undefined;
  } catch {
    return undefined;
  }
}
